
import { Lock, Shield } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const FooterSecurityBanner = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="bg-gradient-to-r from-green-700 to-green-600 text-white py-3 md:py-3">
      <div className="container mx-auto px-2 md:px-4 flex items-center justify-center">
        <div className="flex items-center space-x-2 md:space-x-3 animate-fade-in">
          <Lock className="h-4 w-4 md:h-5 md:w-5 text-white" />
          <span className="text-xs md:text-base font-medium">Turvallinen ja salattu SSL-yhteys</span>
          <Shield className="h-4 w-4 md:h-5 md:w-5 text-white" />
        </div>
      </div>
    </div>
  );
};

export default FooterSecurityBanner;
